import { fetchProductsAll } from "../../../function/manufacturesSlice";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

export default function NewLinkManuscript({
  setAllManus,
  setIsManusFilterActive,
}) {
  const dispatch = useDispatch();
  const allBooksCloseMan = () => {
    dispatch(fetchProductsAll());
    setAllManus(false);
    setIsManusFilterActive(false);
  };
  return (
    <Link
      to="/manuscriptCatalog"
      className="catalogNavLink"
      onClick={allBooksCloseMan}
    >
      Рукописи
    </Link>
  );
}
